// 封装的是具体的接口请求方法
// 每个方法只负责一个请求地址
import request from '@/utils/request'

// 首页分类接口封装
export const sortApi = (pid, lang, admin_id) => {
  return request({
    url: 'index/category',
    method: 'POST',
    params: {
      pid,
      lang,
      admin_id
    }
  })
}

// 首页轮播图接口封装
export const swiperApi = (type, lang, admin_id) => {
  return request({
    url: 'index/banner',
    method: 'POST',
    params: {
      type,
      lang,
      admin_id
    }
  })
}

// 首页爆款推荐产品接口
export const hotApi = (admin_id, lang) => {
  return request({
    url: 'index/hot_goods',
    method: 'POST',
    params: {
      admin_id,
      lang
    }
  })
}

// 首页新产品接口封装
export const newGoodsApi = ({ admin_id, lang }) => {
  return request({
    url: 'index/new_goods',
    method: 'POST',
    params: {
      admin_id,
      lang
    }
  })
}

// 首页降价产品接口封装
export const reduceApi = (admin_id, lang) => {
  return request({
    url: 'index/sale_goods',
    method: 'POST',
    params: {
      admin_id,
      lang
    }
  })
}

// 首页-分类产品接口封装
export const productApi = (admin_id, lang) => {
  return request({
    url: 'index/category_goods',
    method: 'POST',
    params: {
      admin_id,
      lang
    }
  })
}

//  注册-发送邮箱验证码接口封装
export const registerApi = (email, event, lang) => {
  return request({
    url: 'ems/send',
    method: 'POST',
    params: {
      email,
      event,
      lang
    }
  })
}

// 注册-用户注册接口封装
export const regApi = ({ lang, email, code, password, passwordone ,admin_id}) => {
  return request({
    url: 'user/register',
    method: 'POST',
    params: {
      lang,
      email,
      code,
      password,
      passwordone,
      admin_id
    }
  })
}

// 登录-用户登录接口封装
export const loginApi = ({ lang, account, password }) => {
  return request({
    url: 'user/login',
    method: 'POST',
    data: {
      lang,
      account,
      password
    }
  })
}

// 产品中心产品列表接口封装
export const newproductApi = ({
  category_id,
  admin_id,
  is_new,
  is_sale,
  sort,
  lang,
  page,
  pagesize,
  paynumsort
}) => {
  return request({
    url: 'goods/goods_list',
    method: 'POST',
    params: {
      category_id,
      admin_id,
      is_new,
      is_sale,
      sort,
      lang,
      page,
      pagesize,
      paynumsort
    }
  })
}

// 产品中心产品详情接口封装
export const goodsApi = ({ goods_id, lang, user_id }) => {
  return request({
    url: 'goods/goods_view',
    method: 'POST',
    params: {
      goods_id,
      lang,
      user_id
    }
  })
}
// 产品中心推荐商品接口封装
export const tuijian_goodsApi = ({ goods_id, lang, admin_id }) => {
  return request({
    url: 'goods/tuijian_goods',
    method: 'POST',
    params: {
      goods_id,
      lang,
      admin_id
    }
  })
}

// 产品中心-收藏商品接口封装
export const collectApi = ({ goods_id, user_id, lang, admin_id }) => {
  return request({
    url: 'goods/user_goods_collect',
    method: 'POST',
    params: {
      goods_id,
      user_id,
      lang,
      admin_id
    }
  })
}

// 产品中心-添加购物车接口封装
export const addCarApi = (lang, user_id, goods_id, quantity, admin_id) => {
  return request({
    url: 'cart/add',
    method: 'POST',
    params: {
      lang,
      user_id,
      goods_id,
      quantity,
      admin_id
    }
  })
}

// 个人中心-收藏列表接口封装
export const favoriteApi = ({ user_id, lang, page, pagesize, admin_id }) => {
  return request({
    url: 'usercenter/user_collect',
    method: 'POST',
    params: {
      user_id,
      lang,
      page,
      pagesize,
      admin_id
    }
  })
}
// 个人中心-收藏列表删除接口封装
export const deleFavoApi = ({ user_id, collect_id, lang }) => {
  return request({
    url: 'goods/del_user_goods_collect',
    method: 'POST',
    params: {
      user_id,
      collect_id,
      lang
    }
  })
}

// lang	是	int	语言标识
// user_id	是	int	登陆用户id
// company_name	是	string	公司名称
// name	是	string	联系人
// tel	是	string	联系电话
// mobile	是	string	手机号
// 个人中心-申请开店接口封装
export const openStoreApi = ({
  lang,
  user_id,
  company_name,
  name,
  tel,
  mobile,
  admin_id
}) => {
  return request({
    url: 'shop/apply',
    method: 'POST',
    params: {
      lang,
      user_id,
      company_name,
      name,
      tel,
      mobile,
      admin_id
    }
  })
}
// 个人中心-申请开店申请状态
export const openStoreStateApi = (lang, user_id) => {
  return request({
    url: 'shop/get_shop_apply',
    method: 'POST',
    params: {
      lang,
      user_id
    }
  })
}
// 公共接口-文件上传接口封装
export const fileUpApi = (file) => {
  return request({
    url: 'common/upload',
    method: 'POST',
    params: { file }
  })
}
// user_id	是	int	登陆用户id
// lang	是	int	语言类型
// nickname	是	string	昵称
// mobile	是	string	手机号
// avatar	是	string	头像
// gender	是	int	性别 0女 1男
// birthday	是	string	生日 例如2021-12-12
// bio	是	string	格言
// 个人中-修改个人信息接口封装
export const userinfoApi = ({
  user_id,
  lang,
  nickname,
  mobile,
  avatar,
  gender,
  birthday,
  bio,
  company_name
}) => {
  return request({
    url: 'usercenter/up_userinfo',
    method: 'POST',
    params: {
      user_id,
      lang,
      nickname,
      mobile,
      avatar,
      gender,
      birthday,
      bio,
      company_name
    }
  })
}
// 个人中心-获取个人信息接口封装
export const get_userinfoApi = ({ user_id, lang }) => {
  return request({
    url: 'usercenter/get_userinfo',
    method: 'POST',
    params: {
      user_id,
      lang
    }
  })
}

// 个人中心-地址列表接口封装
export const listsApi = ({ lang, user_id, page, pagesize, admin_id }) => {
  return request({
    url: 'address/lists',
    method: 'POST',
    params: {
      lang,
      user_id,
      page,
      pagesize,
      admin_id
    }
  })
}

//个人中心-删除收货地址接口封装
export const del_addressApi = ({ lang, user_id, address_id }) => {
  return request({
    url: 'address/del_address',
    method: 'POST',
    params: {
      lang,
      user_id,
      address_id
    }
  })
}
// 个人中心-获取国家列表
export const get_countryApi = ({ lang }) => {
  return request({
    url: 'address/get_country',
    method: 'POST',
    params: {
      lang
    }
  })
}

// lang	是	int	语言标识
// user_id	是	int	登陆用户id
// address_id	是	int	地址id
// name	是	string	姓名
// company_name	是	string	公司名称
// country_id	是	int	国家id
// address	是	string	详细地址
// zipcode	是	string	邮政编码
// tel	是	string	电话号码
// fax	是	string	传真
// 个人中心-修改地址接口
export const up_addressApi = ({
  lang,
  user_id,
  address_id,
  name,
  company_name,
  country_id,
  address,
  zipcode,
  tel,
  fax
}) => {
  return request({
    url: 'address/up_address',
    method: 'POST',
    params: {
      lang,
      user_id,
      address_id,
      name,
      company_name,
      country_id,
      address,
      zipcode,
      tel,
      fax
    }
  })
}
// 个人中心收货地址详情接口封装
export const get_viewApi = (lang, user_id, address_id) => {
  return request({
    url: 'address/get_view',
    method: 'POST',
    params: {
      lang,
      user_id,
      address_id
    }
  })
}
// 个人中心新增地址接口封装
export const addApi = ({
  lang,
  user_id,
  name,
  company_name,
  country_id,
  address,
  zipcode,
  tel,
  fax,
  admin_id
}) => {
  return request({
    url: 'address/add',
    method: 'POST',
    params: {
      lang,
      user_id,
      name,
      company_name,
      country_id,
      address,
      zipcode,
      tel,
      fax,
      admin_id
    }
  })
}

// 个人中心-修改密码接口封装
export const change_pwdApi = ({
  lang,
  user_id,
  passwordold,
  password,
  passwordone
}) => {
  return request({
    url: 'usercenter/change_pwd',
    method: 'POST',
    params: {
      lang,
      user_id,
      passwordold,
      password,
      passwordone
    }
  })
}

// 采购单列表接口封装
// orders/orders_list
export const orders_listApi = ({
  lang,
  user_id,
  status,
  keyword,
  page,
  pagesize,
  admin_id
}) => {
  return request({
    url: 'orders/orders_list',
    method: 'POST',
    params: {
      lang,
      user_id,
      status,
      keyword,
      page,
      pagesize,
      admin_id
    }
  })
}

// 购物车-获取购物车列表接口封装
export const cart_listsApi = ({ lang, user_id, admin_id }) => {
  return request({
    url: 'cart/cart_lists',
    method: 'POST',
    params: {
      lang,
      user_id,
      admin_id
    }
  })
}

// 右侧悬浮留言接口封装
export const add_liouyanApi = ({ user_id, lang, admin_id, name, content }) => {
  return request({
    url: 'usercenter/add_liouyan',
    method: 'POST',
    params: {
      user_id,
      lang,
      admin_id,
      name,
      content
    }
  })
}

// 个人中心我的留言列表接口封装
export const liouyan_listApi = ({ user_id, lang, page, pagesize }) => {
  return request({
    url: 'usercenter/liouyan_list',
    method: 'POST',
    params: {
      user_id,
      lang,
      page,
      pagesize
    }
  })
}

// 购物车加1接口
export const add_goods_cartApi = ({ lang, user_id, cart_id }) => {
  return request({
    url: 'cart/add_goods_cart',
    method: 'POST',
    params: {
      lang,
      user_id,
      cart_id
    }
  })
}
// 购物车减1接口
export const del_goods_cartApi = ({ lang, user_id, cart_id }) => {
  return request({
    url: 'cart/del_goods_cart',
    method: 'POST',
    params: {
      lang,
      user_id,
      cart_id
    }
  })
}
// cart/del_cart
// 删除购物车接口
export const del_cartApi = ({ lang, user_id, cartids }) => {
  return request({
    url: 'cart/del_cart',
    method: 'POST',
    params: {
      lang,
      user_id,
      cartids
    }
  })
}
// 获取供应商信息
// orders/get_paymentoffline
export const get_paymentofflineApi = ({ lang, user_id, admin_id }) => {
  return request({
    url: 'orders/get_paymentoffline',
    method: 'POST',
    params: {
      lang,
      user_id,
      admin_id
    }
  })
}
// 订单-下单接口orders/add_orders
// lang	是	int	语言标识
// user_id	是	int	登陆用户id
// cart_ids	是	string	购物车ids 例如 1 或者 1,2
// address_id	是	int	收货地址id
// paymentoffline_id	是	int	供应商收款信息id
// delivery_type	是	int	配送方式 0 船运 1空运
// payment	是	double	总金额
// delivery_weight	是	double	总重量
// delivery_volume	是	double	总提交
export const add_ordersApi = ({
  lang,
  user_id,
  cart_ids,
  address_id,
  paymentoffline_id,
  delivery_type,
  payment,
  delivery_weight,
  delivery_volume,
  admin_id
}) => {
  return request({
    url: 'orders/add_orders',
    method: 'POST',
    params: {
      lang,
      user_id,
      cart_ids,
      address_id,
      paymentoffline_id,
      delivery_type,
      payment,
      delivery_weight,
      delivery_volume,
      admin_id
    }
  })
}
// 订单详情接口封装
export const orders_viewApi = ({ lang, user_id, orders_id }) => {
  return request({
    url: 'orders/orders_view',
    method: 'POST',
    params: {
      lang,
      user_id,
      orders_id
    }
  })
}
// 订单进度与接口封装orders/get_orders_status
export const get_orders_statusApi = ({ lang, user_id, orders_id }) => {
  return request({
    url: 'orders/get_orders_status',
    method: 'POST',
    params: {
      lang,
      user_id,
      orders_id
    }
  })
}
// 订单删除接口orders/del_orders
export const del_ordersApi = ({ lang, user_id, orders_id }) => {
  return request({
    url: 'orders/del_orders',
    method: 'POST',
    params: {
      lang,
      user_id,
      orders_id
    }
  })
}
// 订单确认收货接口orders/confirm
export const confirmApi = ({ lang, user_id, orders_id }) => {
  return request({
    url: 'orders/confirm',
    method: 'POST',
    params: {
      lang,
      user_id,
      orders_id
    }
  })
}
// 删除留言接口usercenter/del_liouyan
export const del_liouyanApi = ({ user_id, lang, liouyanids }) => {
  return request({
    url: 'usercenter/del_liouyan',
    method: 'POST',
    params: {
      user_id,
      lang,
      liouyanids
    }
  })
}
// 留言详情接口usercenter/liouyan_view
export const liouyan_viewApi = ({ user_id, lang, liouyan_id }) => {
  return request({
    url: 'usercenter/liouyan_view',
    method: 'POST',
    params: {
      user_id,
      lang,
      liouyan_id
    }
  })
}
// 留言回复接口usercenter/add_liouyan_reply
export const add_liouyan_replyApi = ({
  user_id,
  lang,
  liouyan_id,
  admin_id,
  content
}) => {
  return request({
    url: 'usercenter/add_liouyan_reply',
    method: 'POST',
    params: {
      user_id,
      lang,
      liouyan_id,
      admin_id,
      content
    }
  })
}

// 忘记密码接口user/reset_pwd
export const reset_pwdApi = ({ lang, email, code, password, passwordone }) => {
  return request({
    url: 'user/reset_pwd',
    method: 'POST',
    params: {
      lang,
      email,
      code,
      password,
      passwordone
    }
  })
}
// 加入常购清单接口often/add_often
export const add_oftenApi = ({ lang, user_id, goodsids }) => {
  return request({
    url: 'often/add_often',
    method: 'POST',
    params: {
      lang,
      user_id,
      goodsids
    }
  })
}
// 常购清单列表接口often/lists
export const oftenListsApi = ({ lang, user_id }) => {
  return request({
    url: 'often/lists',
    method: 'POST',
    params: {
      lang,
      user_id
    }
  })
}
// 删除常购清单接口often/del_often
export const del_oftenApi = ({ lang, user_id, oftenids }) => {
  return request({
    url: 'often/del_often',
    method: 'POST',
    params: {
      lang,
      user_id,
      oftenids
    }
  })
}
// 获取开店申请状态shop/get_shop_apply
export const get_shop_applyApi = ({ lang, user_id }) => {
  return request({
    url: 'shop/get_shop_apply',
    method: 'POST',
    params: {
      lang,
      user_id
    }
  })
}
// 订单上传凭证orders/up_pingzheng
export const up_pingzhengApi = ({ lang, user_id, orders_id, pingzheng }) => {
  return request({
    url: 'orders/up_pingzheng',
    method: 'POST',
    params: {
      lang,
      user_id,
      orders_id,
      pingzheng
    }
  })
}
// 店铺信息index/get_shopinfo
export const get_shopinfoApi = ({ admin_id, lang }) => {
  return request({
    url: 'index/get_shopinfo',
    method: 'POST',
    params: {
      admin_id,
      lang
    }
  })
}
// 搜索推荐词接口封装index/search_name
export const search_nameApi = ({ admin_id, lang, keyword }) => {
  return request({
    url: 'index/search_name',
    method: 'POST',
    params: {
      admin_id,
      lang,
      keyword
    }
  })
}
// 搜索列表接口index/search_lists
export const search_listsApi = ({ admin_id, lang, keyword, type, sort }) => {
  return request({
    url: 'index/search_lists',
    method: 'POST',
    params: {
      admin_id,
      lang,
      keyword,
      type,
      sort
    }
  })
}
// 取消订单orders/quxiao
export const quxiaoApi = ({ lang, user_id, orders_id }) => {
  return request({
    url: 'orders/quxiao',
    method: 'POST',
    params: {
      lang,
      user_id,
      orders_id
    }
  })
}

// 发货清单接口
export const shopListApi = ({ lang, user_id, orders_id }) => {
  return request({
    url: 'orders/fhqd',
    method: 'POST',
    params: {
      lang,
      user_id,
      orders_id
    }
  })
}
